import React from 'react';
import { Container } from './styles';

export default function Main() {
  return (
    <Container>
      <h1>On development.</h1>
      <h2>Choose an option on the navbar.</h2>
    </Container>
  );
}
